<rds-sidenav
  [isExpandable]="true"
  [isMinimal]="isMinimal"
  (isMinimalChange)="isMinimal = $event"
>
  <!-- Home (visible on admin panel) -->
  @if (isAdminPanel) {
    <rds-sidenav-group>
      <rds-sidenav-menuitem (click)="navigateToRoot()" [rdsTooltip]="isMinimal ? 'Home' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="home" namespace="outlined"></rds-icon>
        Home
      </rds-sidenav-menuitem>
    </rds-sidenav-group>
  }

  <!-- Filters (homepage only) -->
  @if (!isAdminPanel) {
    <rds-sidenav-group>
      <rds-sidenav-group-title>View</rds-sidenav-group-title>
      <rds-sidenav-menuitem (click)="openFilters()" [rdsTooltip]="isMinimal ? 'Advanced Filters' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="filter_settings" namespace="outlined"></rds-icon>
        Advanced Filters
      </rds-sidenav-menuitem>
    </rds-sidenav-group>
  }

  <!-- Skeleton placeholders while role is loading -->
  @if (!roleLoaded) {
    <rds-sidenav-group>
      <rds-sidenav-group-title>
        <app-skeleton-block width="56px" height="10px" borderRadius="2px"></app-skeleton-block>
      </rds-sidenav-group-title>
      <rds-sidenav-menuitem>
        <app-skeleton-block width="20px" height="20px" borderRadius="4px"></app-skeleton-block>
        <app-skeleton-block width="88px" height="14px" borderRadius="4px"></app-skeleton-block>
      </rds-sidenav-menuitem>
      <rds-sidenav-menuitem>
        <app-skeleton-block width="20px" height="20px" borderRadius="4px"></app-skeleton-block>
        <app-skeleton-block width="96px" height="14px" borderRadius="4px"></app-skeleton-block>
      </rds-sidenav-menuitem>
      <rds-sidenav-menuitem>
        <app-skeleton-block width="20px" height="20px" borderRadius="4px"></app-skeleton-block>
        <app-skeleton-block width="80px" height="14px" borderRadius="4px"></app-skeleton-block>
      </rds-sidenav-menuitem>
    </rds-sidenav-group>

    <rds-sidenav-group>
      <rds-sidenav-group-title>
        <app-skeleton-block width="40px" height="10px" borderRadius="2px"></app-skeleton-block>
      </rds-sidenav-group-title>
      <rds-sidenav-menuitem>
        <app-skeleton-block width="20px" height="20px" borderRadius="4px"></app-skeleton-block>
        <app-skeleton-block width="72px" height="14px" borderRadius="4px"></app-skeleton-block>
      </rds-sidenav-menuitem>
    </rds-sidenav-group>
  }

  <!-- Actions group (editor-only) -->
  @if (roleLoaded && !isViewer) {
    <rds-sidenav-group>
      <rds-sidenav-group-title>Actions</rds-sidenav-group-title>
      <rds-sidenav-menuitem (click)="createActivity()" [rdsTooltip]="isMinimal ? 'Add Activity' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="circle_add" namespace="outlined"></rds-icon>
        Add Activity
      </rds-sidenav-menuitem>
      <rds-sidenav-menuitem (click)="createCustomMilestone()" [rdsTooltip]="isMinimal ? 'Add Milestone' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="flag" namespace="outlined"></rds-icon>
        Add Milestone
      </rds-sidenav-menuitem>
      <rds-sidenav-menuitem (click)="createGslide()" [rdsTooltip]="isMinimal ? 'Create Gslide' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="file_google_slides" namespace="filled"></rds-icon>
        Create Gslide
      </rds-sidenav-menuitem>
    </rds-sidenav-group>
  }

  <!-- Admin group (admin-only) -->
  @if (roleLoaded && (isAdministrator || isSystemAdmin)) {
    <rds-sidenav-group>
      <rds-sidenav-group-title>Admin</rds-sidenav-group-title>
      <rds-sidenav-menuitem (click)="navigateToAdmin('users')" [rdsTooltip]="isMinimal ? 'Manage Users' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="user_group" namespace="outlined"></rds-icon>
        Manage Users
      </rds-sidenav-menuitem>
      <rds-sidenav-menuitem (click)="navigateToAdmin('pillars')" [rdsTooltip]="isMinimal ? 'Manage Strategic Pillars' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="settings" namespace="outlined"></rds-icon>
        Manage Strategic Pillars
      </rds-sidenav-menuitem>
      <rds-sidenav-menuitem (click)="navigateToAdmin('congresses')" [rdsTooltip]="isMinimal ? 'Manage Congress' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
        <rds-icon icon="calendar" namespace="outlined"></rds-icon>
        Manage Congress
      </rds-sidenav-menuitem>
      @if (canAccessAuditLogs) {
        <rds-sidenav-menuitem (click)="navigateToAdmin('audit')" [rdsTooltip]="isMinimal ? 'Audit Log' : ''" rdsTooltipPosition="right-center" [rdsTooltipShowDelay]="50">
          <rds-icon icon="history" namespace="outlined"></rds-icon>
          Audit Log
        </rds-sidenav-menuitem>
      }
    </rds-sidenav-group>
  }

  <!-- Data/Sync group (editor-only, last item) -->
  @if (!isViewer) {
    <rds-sidenav-group>
      <rds-sidenav-group-title>Data</rds-sidenav-group-title>
      <button [rdsSidenavMenuTriggerFor]="syncMenu"
        [rdsTooltip]="isMinimal ? (anySyncOutdated ? anySyncOutdatedTooltip : 'Sync') : ''"
        rdsTooltipPosition="bottom-right" [rdsTooltipShowDelay]="50">
        @if (anySyncOutdated) {
          <rds-icon [icon]="isRefreshing ? 'cloud_download' : 'cloud_done'" namespace="outlined"
            rdsBadge rdsBadgeColor="warning" rdsBadgeLabel=""></rds-icon>
        } @else {
          <rds-icon [icon]="isRefreshing ? 'cloud_download' : 'cloud_done'" namespace="outlined"></rds-icon>
        }
        Sync
      </button>
      <rds-sidenav-menu #syncMenu>
        <rds-sidenav-menuitem
          [style.opacity]="(refreshingSources['publications'] || isRefreshing) ? 0.4 : null" [style.pointer-events]="(refreshingSources['publications'] || isRefreshing) ? 'none' : null"
          (click)="!refreshingSources['publications'] && !isRefreshing && syncSingle('publications')">
          @if (isOutdated('lastPublicationSync')) {
            <rds-icon namespace="outlined" [icon]="refreshingSources['publications'] ? 'cloud_download' : 'repeat'"
              rdsBadge rdsBadgeColor="warning" rdsBadgeLabel=""></rds-icon>
          } @else {
            <rds-icon namespace="outlined" [icon]="refreshingSources['publications'] ? 'cloud_download' : 'repeat'"></rds-icon>
          }
          Sync Publications
          <span style="display:block;font-size:0.75rem;color:var(--rds-color-text-subtle);line-height:1.2;margin-top:2px">Last synced: {{ lastSyncData.lastPublicationSync || 'Never' }}</span>
        </rds-sidenav-menuitem>
        <rds-sidenav-menuitem
          [style.opacity]="(refreshingSources['ctms'] || isRefreshing) ? 0.4 : null" [style.pointer-events]="(refreshingSources['ctms'] || isRefreshing) ? 'none' : null"
          (click)="!refreshingSources['ctms'] && !isRefreshing && syncSingle('ctms')">
          @if (isOutdated('lastMilestoneSync')) {
            <rds-icon namespace="outlined" [icon]="refreshingSources['ctms'] ? 'cloud_download' : 'repeat'"
              rdsBadge rdsBadgeColor="warning" rdsBadgeLabel=""></rds-icon>
          } @else {
            <rds-icon namespace="outlined" [icon]="refreshingSources['ctms'] ? 'cloud_download' : 'repeat'"></rds-icon>
          }
          Sync Milestones
          <span style="display:block;font-size:0.75rem;color:var(--rds-color-text-subtle);line-height:1.2;margin-top:2px">Last synced: {{ lastSyncData.lastMilestoneSync || 'Never' }}</span>
        </rds-sidenav-menuitem>
        <rds-sidenav-menuitem
          [style.opacity]="(refreshingSources['congress'] || isRefreshing) ? 0.4 : null" [style.pointer-events]="(refreshingSources['congress'] || isRefreshing) ? 'none' : null"
          (click)="!refreshingSources['congress'] && !isRefreshing && syncSingle('congress')">
          @if (isOutdated('lastCongressSync')) {
            <rds-icon namespace="outlined" [icon]="refreshingSources['congress'] ? 'cloud_download' : 'repeat'"
              rdsBadge rdsBadgeColor="warning" rdsBadgeLabel=""></rds-icon>
          } @else {
            <rds-icon namespace="outlined" [icon]="refreshingSources['congress'] ? 'cloud_download' : 'repeat'"></rds-icon>
          }
          Sync Congresses
          <span style="display:block;font-size:0.75rem;color:var(--rds-color-text-subtle);line-height:1.2;margin-top:2px">Last synced: {{ lastSyncData.lastCongressSync || 'Never' }}</span>
        </rds-sidenav-menuitem>
        <rds-sidenav-menuitem
          [style.opacity]="(refreshingSources['veeva'] || isRefreshing) ? 0.4 : null" [style.pointer-events]="(refreshingSources['veeva'] || isRefreshing) ? 'none' : null"
          (click)="!refreshingSources['veeva'] && !isRefreshing && syncSingle('veeva')">
          @if (isOutdated('lastVVPMSync')) {
            <rds-icon namespace="outlined" [icon]="refreshingSources['veeva'] ? 'cloud_download' : 'repeat'"
              rdsBadge rdsBadgeColor="warning" rdsBadgeLabel=""></rds-icon>
          } @else {
            <rds-icon namespace="outlined" [icon]="refreshingSources['veeva'] ? 'cloud_download' : 'repeat'"></rds-icon>
          }
          Sync VVPM
          <span style="display:block;font-size:0.75rem;color:var(--rds-color-text-subtle);line-height:1.2;margin-top:2px">Last synced: {{ lastSyncData.lastVVPMSync || 'Never' }}</span>
        </rds-sidenav-menuitem>
        <rds-sidenav-menuitem
          [style.opacity]="(isRefreshing) ? 0.4 : null" [style.pointer-events]="(isRefreshing) ? 'none' : null"
          (click)="!isRefreshing && sync()"
          rdsTooltip="Sync all data sources at once. Use only when needed."
          rdsTooltipPosition="right-center">
          <rds-icon namespace="outlined" [icon]="isRefreshing ? 'cloud_download' : 'refresh'"></rds-icon>
          Sync All
        </rds-sidenav-menuitem>
      </rds-sidenav-menu>
    </rds-sidenav-group>
  }
</rds-sidenav>
